import { h } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import BlogCardBadge from "./blog-card-badge";
import BlogCardVideo from "./blog-card-video";

export default function BlogCard({ article, trackHeight, minHeight = 0 }) {
  const {
    readTime,
    videoPost,
    tags,
    title,
    image,
    onlineStoreUrl,
    id,
    excerpt,
    videoMobile,
    video,
    blogPostImage,
  } = article;

  const contentRef = useRef(null);
  const excerptRef = useRef(null);
  const [play, setPlay] = useState(false);
  const [translateY, setTranslateY] = useState("0px");
  const isVideoPost = videoPost?.value === "true";
  const relativeUrl = new URL(onlineStoreUrl).pathname;
  const mediaVideo = videoMobile?.reference || video?.reference;

  useEffect(() => {
    const calculateHeight = () => {
      if (contentRef?.current) {
        const contentHeight = contentRef.current.getBoundingClientRect().height;
        trackHeight && trackHeight(contentHeight);

        if (excerptRef?.current) {
          const excerptHeight =
            excerptRef.current.getBoundingClientRect().height;
          const blankSpace = minHeight - contentHeight - excerptHeight;
          setTranslateY(
            `${
              blankSpace > 0 ? 0 : excerptHeight - minHeight + contentHeight
            }px`,
          );
        }
      }
    };

    calculateHeight();
    window.addEventListener("resize", calculateHeight);

    return () => window.removeEventListener("resize", calculateHeight);
  }, [minHeight, article, trackHeight]);

  const media = () => {
    if (isVideoPost && mediaVideo) {
      return (
        <BlogCardVideo
          className="blog-card__video"
          video={mediaVideo}
          play={play}
        />
      );
    }

    if (image) {
      let focalPoints = null;
      //let imageUrl = image.url;

      if (image.url) {
        imageUrl = image.url;
      } else {
        imageUrl = image;
      }

      if (blogPostImage) {
        imageUrl = blogPostImage.reference.image.url;

        if (blogPostImage?.reference?.presentation) {
          const { x, y } =
            blogPostImage?.reference?.presentation?.asJson?.focalPoint;
          focalPoints = `${x * 100}% ${y * 100}%`;
        }
      }

      return (
        <img
          className="blog-card__image"
          src={getSizedImageUrl(imageUrl, "x800")}
          style={{
            height: `calc(100% - ${Number(minHeight)}px - 60px)`,
            ...(focalPoints ? { objectPosition: focalPoints } : {}),
          }}
          alt={image.altText}
        />
      );
    }

    return null;
  };

  return (
    <a
      href={relativeUrl}
      className={`blog-card ${
        isVideoPost ? "blog-card--video" : "blog-card--image"
      }`}
      onMouseOver={() => setPlay(true)}
      onMouseLeave={() => setPlay(false)}
    >
      {media()}
      <BlogCardBadge readTime={readTime} videoPost={isVideoPost} />
      <div
        className="blog-card__content"
        style={{ "--translate-y": translateY }}
      >
        <div
          className="blog-card__content-inner-wrapper"
          style={{ minHeight: `${minHeight}px` }}
        >
          <div className="blog-card__content-inner" ref={contentRef}>
            {tags.length > 0 && <div className="blog-card__tag">{tags[0]}</div>}
            <h3 className="h4 strong blog-card__title">{title}</h3>
          </div>
          <div className="blog-card__excerpt" ref={excerptRef}>
            {excerpt}
          </div>
        </div>
      </div>
    </a>
  );
}
